import { jsx as _jsx } from "react/jsx-runtime";
import { MetamaskIcon, PhantomIcon, SolflareIcon, WalletConnectIcon, WalletLinkIcon, } from "../../assets/icons/connector";
import { EthereumWallet, SolanaWallet } from "../../models/wallets";
var WalletLogo = function (_a) {
    var wallet = _a.wallet;
    switch (wallet) {
        case EthereumWallet.Metamask:
            return _jsx(MetamaskIcon, { width: 40, height: 40 }, void 0);
        case EthereumWallet.WalletConnect:
            return _jsx(WalletConnectIcon, { width: 40, height: 40 }, void 0);
        case EthereumWallet.WalletLink:
            return _jsx(WalletLinkIcon, { width: 40, height: 40 }, void 0);
        case SolanaWallet.Phantom:
            return _jsx(PhantomIcon, { width: 40, height: 40 }, void 0);
        case SolanaWallet.Solflare:
            return _jsx(SolflareIcon, { width: 40, height: 40 }, void 0);
        default:
            return null;
    }
};
export default WalletLogo;
//# sourceMappingURL=WalletLogo.js.map